import overrideForm from './override-form'

export default {
    title: 'View and adjust ratings',
    macrotrend: {
        perception: 'Perception available',
        override: 'Override available'
    },
    empty: 'There are no ratings yet',

    overrideForm
}
